<template>
    <div>
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-light" role="status"></div>
            <p>Cargando...</p>
        </div>
        <h5 class="fw-bold fs-4 mb-3">Envío local de urgencia / emergencia - Documentos</h5>
        <form ref="formulario" @submit.prevent="submitForm">
            <div class="card bg-card">
                <div class="card-header">
                    <i class="bi bi-send"></i> Información del Envío
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-lg-4">
                            <label class="required" for="cod_metodo_envio_id">
                                Area Solicitante
                            </label>
                            <select @change="getDetalleMetodoEnvio()" class="form-control"
                                v-model="form.cod_metodo_envio_id" id="cod_metodo_envio_id"
                                :class="{ 'is-invalid': errors.cod_metodo_envio_id }">
                                <option v-for="item in codigosMetodoEnvio" :key="item.id" :value="item.id">
                                    {{ item.codigo }}
                                </option>
                            </select>
                            <div v-if="errors.cod_metodo_envio_id" class="invalid-feedback">
                                {{ errors.cod_metodo_envio_id }}
                            </div>
                        </div>




                        <div class="form-group col-lg-2">
                            <label class="required" for="id_solicitudes_envio">
                                Solicitud de Envío
                            </label>
                            <select class="form-control" v-model="form.id_solicitudes_envio" id="id_solicitudes_envio"
                                :class="{ 'is-invalid': errors.id_solicitudes_envio }"
                                @change="errors.id_solicitudes_envio = false">
                                <option v-for="item in solicitudesEnvio" :value="item.id" :key="item.id">
                                    {{ item.nombre }}
                                </option>
                            </select>
                            <div v-if="errors.id_solicitudes_envio" class="invalid-feedback">
                                {{ errors.id_solicitudes_envio }}
                            </div>
                        </div>

                        <div class="form-group col-lg-2">
                            <label class="required" for="fecha_salida">Fecha de Salida</label>
                            <input type="date" class="form-control" v-model="form.fecha_salida"
                                :min="fechaSalidaMinimaAereo" :class="{ 'is-invalid': errors.fecha_salida }"
                                @input="errors.fecha_salida = false" />
                            <div v-if="errors.fecha_salida" class="invalid-feedback">
                                {{ errors.fecha_salida }}
                            </div>
                        </div>

                        <div class="form-group col-lg-2">
                            <label class="required" for="hora_salida">
                                Horario de Salida
                            </label>
                            <input type="time" class="form-control" v-model="form.hora_salida"
                                @change="changeHoraSalida()" id="hora_salida"
                                :class="{ 'is-invalid': errors.hora_salida }"
                                @input="errors.hora_salida = false" />
                            <div v-if="errors.hora_salida" class="invalid-feedback">
                                {{ errors.hora_salida }}
                            </div>
                        </div>

                        <div class="form-group col-lg-2">
                            <label class="required" for="fecha_entrega">
                                Fecha de Entrega
                            </label>
                            <input type="date" class="form-control" v-model="form.fecha_entrega" id="fecha_entrega"
                                :class="{ 'is-invalid': errors.fecha_entrega }" @input="errors.fecha_entrega = false" />
                            <div v-if="errors.fecha_entrega" class="invalid-feedback">
                                {{ errors.fecha_entrega }}
                            </div>
                        </div>

                        <div class="form-group col-lg-2">
                            <label class="required" for="hora_llegada">
                                Horario de entrega máxima
                            </label>
                            <input type="time" class="form-control" v-model="form.hora_llegada"
                                id="hora_llegada" :class="{ 'is-invalid': errors.hora_llegada }"
                                @input="errors.hora_llegada = false" />
                            <div v-if="errors.hora_llegada" class="invalid-feedback">
                                {{ errors.hora_llegada }}
                            </div>
                        </div>
                        <div class="form-group col-lg-2">
                            <label for="programacion" class="required">Entidad</label>
                            <select v-model="form.programacion" id="programacion" class="form-control"
                                :class="{ 'is-invalid': errors.programacion }">
                                <option value="publico">Público</option>
                                <option value="privado">Privado</option>
                            </select>
                            <div v-if="errors.programacion" class="invalid-feedback">
                                {{ errors.programacion }}
                            </div>
                        </div>
                        <div class="form-group col-lg-2">
                            <label for="tipo_cita">Programación</label>
                            <select v-model="form.tipo_cita" id="tipo_cita" class="form-control"
                                :class="{ 'is-invalid': errors.tipo_cita }">

                                <option value="recojo">Recojo</option>
                                <option value="entrega">Entrega</option>
                            </select>
                            <div v-if="errors.tipo_cita" class="invalid-feedback">
                                {{ errors.tipo_cita }}
                            </div>
                        </div>
                        <div class="form-group col-lg-4">
                            <label for="solicitante">Solicitante</label>
                            <input v-model="form.solicitante" class="form-control" type="text" name="solicitante"
                                id="solicitante">
                            <div v-if="errors.solicitante" class="invalid-feedback">
                                {{ errors.solicitante }}
                            </div>
                        </div>
                        <div class="form-group col-lg-2">
                            <label for="cant_bultos">Cant. Juegos</label>
                             <input type="number" class="form-control" v-model.number="form.cant_bultos"  />
                            <div v-if="errors.cant_bultos" class="invalid-feedback">
                                {{ errors.cant_bultos }}
                            </div>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="horas_extras">Observaciones</label>
                            <textarea name="" v-model="form.observaciones" class="form-control no-resize" id=""
                                cols="30" rows="5"></textarea>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="horas_extras" class="required">Motivo de la Emergencia/Urgencia</label>
                            <textarea required name="" v-model="form.observaciones_emergencia"
                                class="form-control no-resize" id="" cols="30" rows="5"></textarea>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card bg-card mt-4">
                        <div class="card-header">
                            <i class="bi bi-file-earmark-text"></i> Documentos del envío
                        </div>
                        <div class="card-body">
                            <!-- Formulario para agregar documento -->

                            <div class="row">
                                <div class="form-group col-lg-4">
                                    <label class="required" for="detalle_metodo_envio_id">
                                        Detalle del Area Solicitante
                                    </label>
                                    <select class="form-control" v-model="formDocumento.detalle_metodo_envio_id"
                                        id="detalle_metodo_envio_id"
                                        :class="{ 'is-invalid': errors.detalle_metodo_envio_id }"
                                        @change="errors.detalle_metodo_envio_id = false">
                                        <option v-for="item in detallesMetodoEnvio" :key="item.id" :value="item.id">
                                            {{ item.detalle }}
                                        </option>
                                    </select>
                                    <div v-if="errors.detalle_metodo_envio_id" class="invalid-feedback">
                                        {{ errors.detalle_metodo_envio_id }}
                                    </div>
                                </div>
                                <div class="form-group col-lg-2">
                                    <label for="orden_compra">N° Orden de compra</label>
                                    <input type="text" v-model="formDocumento.orden_compra" id="orden_compra"
                                        class="form-control" />
                                </div>
                                <div class="form-group col-lg-2">
                                    <label for="numero_factura">N° factura</label>
                                    <input type="text" v-model="formDocumento.numero_factura" id="numero_factura"
                                        class="form-control" />
                                </div>
                                <div class="form-group col-lg-1">
                                    <label for="otm">N° OTM</label>
                                    <input type="text" v-model="formDocumento.otm" id="otm" class="form-control" />
                                </div>
                                <div class="form-group col-lg-2">
                                    <label for="documentos_extras">Documentos extras</label>
                                    <input type="text" v-model="formDocumento.documentos_extras" id="documentos_extras"
                                        class="form-control" />
                                </div>
                                <div class="form-group col-md-1 d-flex align-items-end">
                                    <a role="button"
                                        class="btn btn-sm btn-info d-flex align-items-center gap-2 text-white"
                                        @click="agregarDocumento">
                                        <i class="bi bi-plus-circle"></i>
                                    </a>
                                </div>

                            </div>

                            <div class="row mt-4">
                                <div class="col-lg-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="table-responsive mt-2">
                                                <table class="table table-font-small">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th>Detalle del Area Solicitante</th>
                                                            <th>N° Orden Compra</th>
                                                            <th>N° factura</th>
                                                            <th>N° OTM</th>
                                                            <th>Documentos extras</th>
                                                            <th>Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(doc, index) in form.documentos" :key="index">
                                                            <td>{{ getDetalleMetodoEnvioById(doc.detalle_metodo_envio_id) }}</td>
                                                            <td>{{ doc.orden_compra }}</td>
                                                            <td>{{ doc.numero_factura }}</td>
                                                            <td>{{ doc.otm }}</td>
                                                            <td>{{ doc.documentos_extras }}</td>
                                                            <td>
                                                                <a class="btn btn-sm btn-danger text-white" role="button"
                                                                    @click="eliminarDocumento(index)">
                                                                    <i class="bi bi-trash"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="form.documentos.length === 0">
                                                            <td colspan="6" class="text-center">No hay documentos agregados</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-if="errors.documentos" class="text-danger mt-2">
                                                <small>{{ errors.documentos }}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>



                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <div class="card bg-card mt-4">
                        <div class="card-header">
                            <i class="bi bi-building"></i> Información del Remitente
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="form-group row">
                                    <div class="col-md-9">
                                        <label class="required" for="ruc_remitente">
                                            RUC Remitente
                                        </label>
                                        <input v-model="form.ruc_remitente"
                                            :class="{ 'is-invalid': errors.ruc_remitente }" id="ruc_remitente"
                                            @input="errors.ruc_remitente = false" class="form-control" />
                                    </div>
                                    <div class="col-md-3">
                                        <br />
                                        <a role="button"
                                            class="btn btn-primary text-white btn-sm align-items-center gap-2"
                                            @click="getEmpresaRemitente()">
                                            <i class="bi bi-search"></i>
                                            Buscar
                                        </a>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-lg-9">
                                        <label class="required" for="remitente">Remitente (Cliente Inicial)</label>
                                        <select v-model="form.remitente" :class="{ 'is-invalid': errors.remitente }"
                                            disabled id="remitente" @change="getSucursalesRemitente()"
                                            class="form-control">
                                            <option v-for="item in empresas" :key="item.id" :value="item.id">
                                                {{ item.nombre }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3">
                                        <br />
                                        <a role="button" v-if="form.remitente"
                                            class="btn btn-primary btn-sm mx-1 text-white"
                                            @click="openModalDirecciones(form.remitente, sucursalesRemitente, 'remitente')">
                                            <i class="bi bi-gear me-1"></i> Gestionar
                                        </a>

                                    </div>

                                </div>

                                <div class="form-group">
                                    <label class="required" for="id_direccion_sucursal_origen">
                                        Seleccione Dirección del Remitente (Cliente Final)
                                    </label>
                                    <SelectDireccion v-model="form.id_direccion_sucursal_origen" :options="sucursalesRemitente"
                                      id="id_direccion_sucursal_origen" :class="{ 'is-invalid': errors.id_direccion_sucursal_origen }"
                                      placeholder="Seleccione Dirección del Remitente (Cliente Final)"
                                      @change="buscarDireccionRemitente()" />

                                    <label class="mt-2" for="id_contacto_sucursal_origen">
                                        Contacto del Remitente
                                    </label>
                                    <input readonly :value="sucursalRemitente && sucursalRemitente.nombre_contacto"
                                        id="id_direccion_sucursal_origen" type="text" class="form-control" />
                                    <label for="id_contacto_sucursal_origen">
                                        Telefono de Contacto
                                    </label>
                                    <input readonly :value="sucursalRemitente && sucursalRemitente.telefono_contacto"
                                        id="id_direccion_sucursal_origen" type="text" class="form-control" />
                                    <label for="id_contacto_sucursal_origen">
                                        Area de Atención
                                    </label>
                                    <input readonly :value="sucursalRemitente && sucursalRemitente.cargo_contacto"
                                        id="id_cargo_contacto" type="text" class="form-control" />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="card bg-card mt-4">
                        <div class="card-header">
                            <i class="bi bi-geo-alt"></i> Información del Destinatario
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="form-group row">
                                    <div class="col-md-9">
                                        <label class="required" for="ruc_destinatario">
                                            RUC Destinatario
                                        </label>
                                        <input v-model="form.ruc_destinatario"
                                            :class="{ 'is-invalid': errors.ruc_destinatario }" id="ruc_destinatario"
                                            class="form-control" @input="errors.ruc_destinatario = false" />


                                    </div>
                                    <div class="col-md-3">
                                        <br />
                                        <a role="button"
                                            class="btn btn-primary text-white btn-sm align-items-center gap-2"
                                            @click="getEmpresaDestinatario()">
                                            <i class="bi bi-search"></i>
                                            Buscar
                                        </a>
                                    </div>
                                </div>
                                <div class="form-group row">


                                    <div class="col-lg-9">
                                        <label class="required" for="destinatario">
                                            Destinatario (Cliente Inicial)
                                        </label>
                                        <select disabled v-model="form.destinatario"
                                            :class="{ 'is-invalid': errors.destinatario }" id="destinatario"
                                            @change="getSucursalesDestinatario()" class="form-control">
                                            <option v-for="item in empresas" :key="item.id" :value="item.id">
                                                {{ item.nombre }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3">
                                        <br />
                                        <a role="button" v-if="form.destinatario"
                                            class="btn btn-primary btn-sm mx-1 text-white"
                                            @click="openModalDirecciones(form.destinatario, sucursalesDestinatario, 'destinatario')">
                                            <i class="bi bi-gear me-1"></i> Gestionar
                                        </a>

                                    </div>
                                </div>



                                <div class="form-group">
                                    <label class="required" for="id_direccion_sucursal_destino">
                                        Seleccione Dirección del Destinatario (Cliente Final)
                                    </label>
                                    <SelectDireccion v-model="form.id_direccion_sucursal_destino" :options="sucursalesDestinatario"
                                      id="id_direccion_sucursal_destino" :class="{ 'is-invalid': errors.id_direccion_sucursal_destino }"
                                      placeholder="Seleccione Dirección del Destinatario (Cliente Final)"
                                      @change="buscarDireccionDestinatario()" />
                                    <label class="mt-2" for="id_contacto_sucursal_origen">
                                        Contacto del Destinatario
                                    </label>
                                    <input readonly
                                        :value="sucursalDestinatario && sucursalDestinatario.nombre_contacto"
                                        id="id_direccion_sucursal_origen" type="text" class="form-control" />
                                    <label for="id_contacto_sucursal_origen">
                                        Telefono de Contacto
                                    </label>
                                    <input readonly
                                        :value="sucursalDestinatario && sucursalDestinatario.telefono_contacto"
                                        id="id_direccion_sucursal_origen" type="text" class="form-control" />

                                    <label for="id_cargo_contacto">
                                        Area de Atención
                                    </label>
                                    <input readonly :value="sucursalDestinatario && sucursalDestinatario.cargo_contacto"
                                        id="id_cargo_contacto" type="text" class="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bg-card mt-4">
                <div class="card-header"><i class="bi bi-truck"></i> Selección de Vehículo</div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-lg-6">
                            <label class="required" for="origen_distrito">
                                Tipo de unidad
                            </label>
                            <select v-model="form.tipo_unidad_asignada" id="tipo_unidad_asignada"
                                @change="buscarUnidad()" class="form-control font-small">
                                <option v-for="item in tipoUnidades" :key="item.id" :value="item.id">
                                    {{ item.tipo_unidad }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group col-lg-21">
                            <label for="peso">Precio</label>
                            <input type="text" v-model="form.precio_servicio" id="peso" disabled class="form-control" />
                        </div>
                        <div class="form-group col-lg-12">
                            <span @click="showdetalleUnidad = !showdetalleUnidad" class="text-primary hover-pointer">
                                Ver Detalles de la unidad
                            </span>
                            <br />
                            <div v-if="showdetalleUnidad" class="card mt-2">
                                <div class="card-body">
                                    <div class="table-responsive mt-4">
                                        <table class="table table-font-small">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Capacidad de peso (TN)</th>
                                                    <th>Capacidad de carga ( M3)</th>
                                                    <th>Medidas del transporte</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{ detalleUnidad.capacidad_peso }}</td>
                                                    <td>{{ detalleUnidad.capacidad_carga }}</td>
                                                    <td>{{ detalleUnidad.medidas_transporte }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="tipoEnvio == 'exclusivo'" class="card bg-card mt-4">
                <div class="card-header"><i class="bi bi-plus-square"></i> Servicios Extras</div>
                <div class="card-body">
                    <div class="row mt-2">
                        <div class="col-md-3">
                            <label>Servicio</label>
                            <select class="form-control" v-model="servicioSeleccionado" @change="cargarDatosServicio">
                                <option value="">Seleccione un servicio</option>
                                <option v-for="serv in serviciosExtras" :key="serv.id" :value="serv">
                                    {{ serv.servicio }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label>Cantidad</label>
                            <input type="number" class="form-control" v-model.number="cantidad"
                                @input="calcularTotal" />
                        </div>
                        <div class="col-md-2">
                            <label>Costo por Hora (S/.)</label>
                            <input type="number" class="form-control" v-model="costoPorHora" disabled />
                        </div>
                        <div class="col-md-2">
                            <label>Costo por Día (S/.)</label>
                            <input type="number" class="form-control" v-model="costoPorDia" disabled />
                        </div>
                        <div class="col-md-2">
                            <label>Total (S/.)</label>
                            <input type="number" class="form-control" v-model="total" disabled />
                        </div>
                        <div class="col-md-1 d-flex align-items-end">
                            <button class="btn btn-sm btn-warning d-flex align-items-center gap-2"
                                @click="agregarServicio">
                                <i class="bi bi-plus-circle"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Tabla de servicios agregados -->
                    <div class="mt-4">
                        <div class="table-responsive text-nowrap">
                            <table class="table table-font-small">
                                <thead class="table-light">
                                    <tr>
                                        <th>Servicio</th>
                                        <th>Cantidad</th>
                                        <th>Costo por Hora (S/.)</th>
                                        <th>Costo por Día (S/.)</th>
                                        <th>Total (S/.)</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody class="table-border-bottom-0">
                                    <tr v-for="(serv, index) in serviciosAgregados" :key="index">
                                        <td>{{ serv.servicio }}</td>
                                        <td>{{ serv.cantidad }}</td>
                                        <td>{{ serv.costoPorHora }}</td>
                                        <td>{{ serv.costoPorDia }}</td>
                                        <td>{{ serv.total }}</td>
                                        <td>
                                            <button class="btn btn-danger btn-sm" @click="eliminarServicio(index)">
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="tipoEnvio == 'consolidado' || tipoEnvio == 'aereo'" class="card bg-card mt-4">
                <div class="card-header"><i class="bi bi-box-seam"></i> Información del Paquete</div>
                <div class="card-body">
                    <div class="row my-2">
                        <!-- Tipo de paquete -->
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-2">
                                    <label>Nombre del Paquete</label>
                                    <input type="text" class="form-control" v-model="nombrePaquete" />
                                </div>
                                <div class="col-md-1">
                                    <label>Alto (cm)</label>
                                    <input type="number" step="0.01" class="form-control" v-model.number="alto" />
                                </div>
                                <div class="col-md-1">
                                    <label>Ancho (cm)</label>
                                    <input type="number" step="0.01" class="form-control" v-model.number="ancho" />
                                </div>
                                <div class="col-md-1">
                                    <label>Largo (cm)</label>
                                    <input type="number" step="0.01" class="form-control" v-model.number="largo" />
                                </div>
                                <div class="col-md-1">
                                    <label>Peso Real (kg)</label>
                                    <input type="number" step="0.01" class="form-control" v-model.number="pesoReal" />
                                </div>

                                <div class="col-md-1">
                                    <label>Costo kg(S/.)</label>
                                    <input disabled type="number" step="0.01" class="form-control"
                                        v-model.number="costoPorKg" />
                                </div>
                                <div class="col-md-1">
                                    <label>Peso Vol (kg)</label>
                                    <input disabled type="number" step="0.01" class="form-control"
                                        v-model.number="pesoVolumetrico" />
                                </div>
                                <div class="col-md-1 mt-4">
                                    <a role="button"
                                        class="btn btn-secondary btn-sm text-white d-flex align-items-center gap-2"
                                        @click="calcularCosto">
                                        <i class="bi bi-calculator"></i>
                                        Calcular
                                    </a>
                                </div>

                                <div class="col-md-2">
                                    <label>Costo Paquete(S/.)</label>
                                    <input disabled type="number" step="0.01" class="form-control"
                                        v-model.number="costoPaquete" />
                                </div>
                                <div class="col-md-1 mt-4">
                                    <a role="button"
                                        class="btn btn-info btn-sm text-white d-flex align-items-center gap-2"
                                        @click="agregarPaquete">
                                        <i class="bi bi-plus-circle"></i>
                                        Agregar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Tabla de paquetes agregados -->
                    <div v-if="paquetes.length > 0" class="mt-4">
                        <h5>Paquetes Agregados</h5>
                        <table class="table table-font-small">
                            <thead class="table-light">
                                <tr>
                                    <th>Nombre</th>
                                    <th>Alto (cm)</th>
                                    <th>Ancho (cm)</th>
                                    <th>Largo (cm)</th>
                                    <th>Peso (kg)</th>
                                    <th>Peso volumétrico</th>
                                    <th>Costo</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(paquete, index) in paquetes" :key="index">
                                    <td>{{ paquete.nombre }}</td>
                                    <td>{{ paquete.alto }}</td>
                                    <td>{{ paquete.ancho }}</td>
                                    <td>{{ paquete.largo }}</td>
                                    <td>{{ paquete.peso }}</td>
                                    <td>{{ paquete.pesoVolumetrico }}</td>
                                    <td>{{ paquete.costo }}</td>
                                    <td>
                                        <button class="btn btn-danger btn-sm" @click="eliminarPaquete(index)">
                                            Eliminar
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row mt-4">
                        <hr />
                        <div class="col-md-4"></div>
                        <div class="col-md-2">
                            <label>Total Paquetes</label>
                            <input type="number" class="form-control" v-model.number="form.cant_bultos" disabled />
                        </div>
                        <div class="col-md-2">
                            <label>Total Peso Volumétrico (kg)</label>
                            <input type="number" step="0.01" class="form-control" v-model.number="form.peso_volumen"
                                disabled />
                        </div>
                        <div class="col-md-2">
                            <label>Total Peso Real (kg)</label>
                            <input type="number" step="0.01" class="form-control" v-model.number="form.peso_bruto"
                                disabled />
                        </div>
                        <div class="col-md-2">
                            <label>Costo Total (S/.)</label>
                            <input type="number" step="0.01" class="form-control" v-model.number="costoTotal"
                                disabled />
                        </div>
                    </div>
                </div>
            </div>
             <!-- Sección de Paradas -->
            <div class="col-lg-12">
                <div class="card bg-card mt-4">
                    <div class="card-header"><i class="bi bi-signpost-split"></i> Paradas (máximo 3)</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-lg-3">
                                <label>Nombre - Celular</label>
                                <input type="text" class="form-control" v-model="nuevaParada.nombre" />
                            </div>
                            <div class="form-group col-lg-3">
                                <label>Distrito</label>
                                <select class="form-control" v-model="nuevaParada.distrito_id">
                                    <option value="">Seleccione un distrito</option>
                                    <option v-for="item in distritosLocal" :value="item.id" :key="item.id">{{
                                        item.nombre }}</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-3">
                                <label>Dirección</label>
                                <input type="text" class="form-control" v-model="nuevaParada.direccion" />
                            </div>
                            <div class="form-group col-lg-2">
                                <label>Horario</label>
                                <input type="time" class="form-control" v-model="nuevaParada.horario" />
                            </div>
                            <div class="form-group col-lg-1 d-flex align-items-end">
                                <button class="btn btn-sm btn-primary"
                                    :disabled="paradas.length >= 3 || !nuevaParada.nombre || !nuevaParada.distrito_id || !nuevaParada.direccion"
                                    @click="agregarParada">Agregar</button>
                            </div>
                        </div>
                        <div v-if="paradas.length > 0" class="mt-3">
                            <table class="table table-font-small">
                                <thead class="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th>Distrito</th>
                                        <th>Dirección</th>
                                        <th>Horario</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(parada, index) in paradas" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ parada.nombre }}</td>
                                        <td>{{ obtenerNombreDistrito(parada.distrito_id) }}</td>
                                        <td>{{ parada.direccion }}</td>
                                        <td>{{ parada.horario }}</td>
                                        <td>
                                            <button class="btn btn-danger btn-sm"
                                                @click="eliminarParada(index)">Eliminar</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="paradas.length >= 3" class="text-danger">Solo se permiten hasta 3 paradas.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4 d-flex justify-content-end mb-3">
                <button type="submit" class="btn btn-primary d-flex align-items-center gap-2">
                    <i class="bi bi-floppy"></i>
                    Guardar
                </button>
            </div>




            <!--<button type="button" class="btn btn-secondary d-flex align-items-center gap-2 me-2" @click="closeModal">
                    <i class="bi bi-x-circle"></i>
                    Cancelar
                </button>-->

        </form>
        <div v-if="showModalDirecciones" class="modal fade show d-block" tabindex="-1"
            style="background: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Gestionar Direcciones</h5>
                        <button type="button" class="btn-close" @click="showModalDirecciones = false"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarDireccion">
                            <div class="row">
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Cliente Final</label>
                                    <input type="text" class="form-control" v-model="direccionEdit.nombre" required />
                                </div>
                                <div class="mb-3 col-lg-8">
                                    <label class="form-label">Dirección</label>
                                    <input type="text" class="form-control" v-model="direccionEdit.direccion"
                                        required />
                                </div>
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Departamento</label>
                                    <select class="form-control" @change="cargarProvincias()"
                                        v-model="direccionEdit.departamento_id" required>
                                        <option v-for="item in departamentos" :value="item.id" :key="item.id">{{
                                            item.nombre }}</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Provincia</label>
                                    <select @change="cargarDistritos()" class="form-control"
                                        v-model="direccionEdit.provincia_id" required>
                                        <option v-for="item in provincias" :value="item.id" :key="item.id">{{
                                            item.nombre }}</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Distrito</label>
                                    <select class="form-control" v-model="direccionEdit.distrito_id" required>
                                        <option v-for="item in distritos" :value="item.id" :key="item.id">{{ item.nombre
                                            }}</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Nombre Contacto</label>
                                    <input type="text" class="form-control" v-model="direccionEdit.nombre_contacto" />
                                </div>
                                <div class="mb-3 col-lg-3">
                                    <label class="form-label">Área de atención</label>
                                    <input type="text" class="form-control" v-model="direccionEdit.cargo_contacto" />
                                </div>
                                <div class="mb-3 col-lg-2">
                                    <label class="form-label">Teléfono Contacto</label>
                                    <input type="text" class="form-control" v-model="direccionEdit.telefono_contacto" />
                                </div>

                            </div>
                            <div class="d-flex justify-content-end mb-3">
                                <a @click="resetDireccion()" class="btn btn-danger text-white mx-2">
                                    <i class="bi bi-x-circle me-1"></i> Cancelar
                                </a>
                                <button type="submit" class="btn btn-primary">
                                    <i class="bi bi-floppy  me-1"></i> Guardar Dirección
                                </button>

                            </div>
                        </form>
                        <div class="table-responsive text-nowrap">
                            <!-- Tabla de direcciones -->
                            <table class="table table-font-small mt-4">
                                <thead class="table-light">
                                    <tr>
                                        <th>Cliente Final</th>
                                        <th>Dirección</th>
                                        <th>Departamento</th>
                                        <th>Provincia</th>
                                        <th>Distrito</th>
                                        <th>Contacto</th>
                                        <th>Area de atención</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="direccion in sucursalesData" :key="direccion.id">
                                        <td>{{ direccion.nombre }}</td>
                                        <td>{{ direccion.direccion }}</td>
                                        <td>{{ direccion.departamento_nombre }}</td>
                                        <td>{{ direccion.provincia_nombre }}</td>
                                        <td>{{ direccion.distrito_nombre }}</td>
                                        <td>{{ direccion.nombre_contacto }} {{ direccion.telefono_contacto }}</td>
                                        <td>{{ direccion.cargo_contacto }}</td>
                                        <td>
                                            <button class="btn btn-warning btn-sm me-2"
                                                @click="editarDireccion(direccion)">
                                                <i class="bi bi-pencil-square"></i>
                                            </button>
                                            <button class="btn btn-danger btn-sm"
                                                @click="eliminarDireccion(direccion.id)">
                                                <i class="bi bi-trash3-fill"></i>
                                            </button>

                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import SelectDireccion from '@/components/SelectDireccion.vue'
export default {
    name: 'ShippingLocalPage',
    components: { SelectDireccion },
    props: {
        fechaSalida: String,
        horarioSalida: String,
        fechaEntrada: String,
        personalChofer: Number,
        idVehiculo: Number,
        tipoUnidadAsignada: Number,
        idProgramacion: Number
    },
    data() {
        return {
            // Paradas
            paradas: [],
            nuevaParada: {
                nombre: '',
                distrito_id: '',
                direccion: '',
                horario: ''
            },
            fechaSalidaMinimaAereo: "",
            isLoading: true,
            envioId: this.$route.params.id,
            editandoDireccion: false,
            tipoEnvio: this.$route.params.tipo_envio,
            tipoEnvioLabel: '',
            rangosHoras: this.generarRangosHoras(),
            showModalDirecciones: false,
            errors: {},
            pedidoResponse: {},
            sucursalRemitente: {},
            departamentos: [],
            provincias: [],
            distritos: [],
            tipoDireccion: '',
            formDocumento: {
                detalle_metodo_envio_id: '',
                guia_remitente: '',
                nro_pedido: '',
                orden_compra: '',
                numero_factura: '',
                documentos_extras: '',
                otm: ''
            },
            direccionEdit: {
                empresa_id: null,
                nombre: '',
                direccion: '',
                distrito_id: null,
                nombre_contacto: '',
                cargo_contacto: '',
                telefono_contacto: '',
                email_contacto: '',
            },
            form: {
                tipo_evento: 'normal',
                personal_chofer: this.personalChofer,
                id_vehiculo: this.idVehiculo,
                tipo_unidad_asignada: '',
                id_direccion_sucursal_origen: '',
                id_direccion_sucursal_destino: '',
                fecha_salida: this.fechaSalida || '',
                hora_salida: this.horarioSalida || '',
                fecha_entrega: this.fechaEntrada || '',
                dias_entrega: '',
                horas_extra: '',
                cod_metodo_envio_id: '',
                detalle_metodo_envio_id: '',
                documentos: [],
                documentos_extras: '',
                cant_bultos: '',
                cant_conductor: '1',
                precio_servicio: '',
                peso_bruto: '',
                peso_volumen: '',
                tipo_unidad: '1',
                medidas: '',
                flete: '',
                falso_flete_provincia: '',
                flete_cancelacion: '',
                flete_visita_extra: '',
                flete_hora_extra: '',
                flete_local_urgencia: '',
                gastos_admin: '',
                gastos_total: '',
                detalle_gastos_admin: '',
                id_causa_visita: '',
                detalle_causa_visita: '',
                detalle_mercaderia: '',
                id_modalidades_envio: '3',
                id_tipo_envio: '',
                id_solicitudes_envio: '1',
                detalle_solicitud_envio: 'EMERGENCIA',
                estado_entrega: '1',
                id_causa_entrega: '',
                detalle_causa_entrega: '',
                lead_time_esperado: '4 Horas',
                cumplimiento_lead_time: '',
                causa_cumplimiento_lead_time: '',
                detalle_cumplimiento_lead_time: '',
                lead_time_cargos: '',
                causa_cumplimiento_lead_time_cargos: '',
                estado_retorno_cargos: '',
                lead_time_retorno_doc: '',
                cumplimiento_lead_time_retorno: '',
                causa_cumplimiento_lead_time_retorno: '',
                conformidad: '',
                observaciones: '',
                observacion_final: '',
                hora_llegada: '',
                tipo_paquete: 'documentos',
                modalidad_envio: 'EXCLUSIVO',
                agencia: '',
                programacion: 'normal',
                tipo_cita: '',
                hora_llegada_maxima: '',
                solicitante: '',
                observaciones_emergencia: ''
            },
            codigosMetodoEnvio: [],
            detallesMetodoEnvio: [],
            tiposEnvio: [],
            empresas: [],
            tipoUnidades: [],
            sucursalesRemitente: [],
            sucursalesDestinatario: [],

            sucursalesData: [],

            detalleUnidad: '',
            showdetalleUnidad: false,
            sucursalDestinatario: {},
            serviciosExtras: [],

            // Variables del formulario
            servicioSeleccionado: '',
            cantidad: 1,
            costoPorHora: 0,
            costoPorDia: 0,
            total: 0,
            // Lista de servicios agregados
            serviciosAgregados: [],
            solicitudesEnvio: [],
            nombrePaquete: '',
            alto: 0,
            largo: 0,
            ancho: 0,
            pesoReal: 0,
            pesoVolumetrico: 0,
            costoPorKg: 0,
            costoPaquete: 0,
            paquetes: [],
            tipo_costo: 'peso_volumen',
        }
    },
    async mounted() {
        this.isLoading = true;
        this.validarFechaSalida()
        console.log("idProgramacion", this.idProgramacion)
        const user = JSON.parse(localStorage.getItem("user"));
        this.form.solicitante = `${user.name} ${user.apellido}`;
        await this.getCodigoMetodoEnvio()
        await this.getTipoEnvio()
        await this.getEmpresas()
        await this.getTipoUnidades()
        await this.buscarUnidad()
        await this.getServiciosExtras()
        await this.getSolicitudesEnvio()
        await this.cargarDepartamentos();
        if (this.idProgramacion > 0) {
            await this.getEnvio()
            await this.getDetalleMetodoEnvio()
        }
        await this.getSucursalesRemitente()
        await this.getSucursalesDestinatario()
        this.isLoading = false;
        this.cargarDistritosLocal();
    },
    computed: {
        totalPaquetes() {
            return this.paquetes.length
        },
        totalPesoVolumetrico() {
            return this.paquetes.reduce((total, p) => total + p.pesoVolumetrico, 0)
        },
        totalPesoReal() {
            return this.paquetes.reduce((total, p) => total + p.peso, 0)
        },
        costoTotal() {
            return this.paquetes.reduce((total, p) => total + p.costo, 0)
        },
    },
    watch: {
        form: {
            handler(newForm) {
                if (newForm.destinatario) {
                    this.errors.destinatario = false
                }
                if (newForm.id_direccion_sucursal_destino) {
                    this.errors.id_direccion_sucursal_destino = false
                }
                if (newForm.remitente) {
                    this.errors.remitente = false
                }
                if (newForm.id_direccion_sucursal_origen) {
                    this.errors.id_direccion_sucursal_origen = false
                }
            },
            deep: true, // Permite observar cambios en propiedades internas de `form`
        },
        paquetes: {
            handler(newVal) {
                this.form.cant_bultos = newVal.length
                this.form.peso_volumen = newVal.reduce(
                    (total, p) => total + p.pesoVolumetrico,
                    0,
                )
                this.form.peso_bruto = newVal.reduce((total, p) => total + p.peso, 0)
            },
            deep: true,
        },
    },
    methods: {
                agregarParada() {
                    if (this.paradas.length < 3 && this.nuevaParada.nombre && this.nuevaParada.distrito_id && this.nuevaParada.direccion) {
                        this.paradas.push({ ...this.nuevaParada });
                        this.nuevaParada = { nombre: '', distrito_id: '', direccion: '', horario: '' };
                    }
                },
                eliminarParada(index) {
                    this.paradas.splice(index, 1);
                },
                obtenerNombreDistrito(id) {
                    const distrito = this.distritos.find(d => d.id === id);
                    return distrito ? distrito.nombre : '';
                },
        validarFechaSalida() {
            const ahora = new Date();
            let fechaMin = new Date();

            if (ahora.getHours() >= 16) {
                fechaMin.setDate(fechaMin.getDate() + 1);
            }
            const yyyy = fechaMin.getFullYear();
            const mm = String(fechaMin.getMonth() + 1).padStart(2, '0');
            const dd = String(fechaMin.getDate()).padStart(2, '0');

            this.fechaSalidaMinimaAereo = `${yyyy}-${mm}-${dd}`;

        },
        async cargarDistritosLocal() {
            try {
                const response = await axios.get('/distritosLocal')
                this.distritosLocal = response.data
            } catch (error) {
                console.error('Error al cargar distritos', error)
            }
        },
        changeHoraSalida() {
            if (this.form.hora_salida != "") {
                const [horaStr, minStr] = this.form.hora_salida.split(':');

                console.log("horaStr", parseInt(horaStr))
                console.log("minStr", parseInt(minStr))
                let horaMAxima = 17
                let horaMAximaString = "5:00 p.m"

                if (parseInt(horaStr) > horaMAxima || (parseInt(horaStr) == horaMAxima && parseInt(minStr) >= 1)) {
                    this.form.hora_salida = ""
                    Swal.fire("Advertencia", "la hora de Salida, no puede ser mayor de las " + horaMAximaString);
                    return;
                } else {
                    this.getTipoEnvio()
                    this.getSolicitudesEnvio()
                }
            }
        },
        getDetalleMetodoEnvioById(detalle_metodo_envio_id) {
            return this.detallesMetodoEnvio.find(item => item.id == detalle_metodo_envio_id).detalle;
        },
        async cargarDepartamentos() {
            try {
                this.provincias = [];
                const response = await axios.get('/departamentos')
                this.departamentos = response.data
            } catch (error) {
                console.error('Error al cargar departamentos', error)
            }
        },
        async cargarProvincias() {
            try {
                this.distritos = []
                const response = await axios.get('/provinciasByDepartamentos/' + this.direccionEdit.departamento_id)
                this.provincias = response.data
            } catch (error) {
                console.error('Error al cargar provincias', error)
            }
        },
        async cargarDistritos() {
            try {
                const response = await axios.get('/distritosByProvincias/' + this.direccionEdit.provincia_id)
                this.distritos = response.data
            } catch (error) {
                console.error('Error al cargar distritos', error)
            }
        },
        async getEnvio() {
            try {
                const response = await axios.get('enviosByProgramacion/' + this.idProgramacion)
                console.log("response", response.data.observacion_final)
                response.data.documentos = response.data.detalles || response.data.documentos || []
                this.form = response.data
                this.form.cod_metodo_envio_id = this.form.metodo_envio_id
                this.form.observaciones = response.data.observacion_final
                this.form.observacion_final = response.data.observacion_final // Usar response.data
                //this.buscarDireccionRemitente()
            } catch (error) {
                console.error('Error cargando detalles de envío:', error)
            }
        },
        getFormData() {
            return {
                id_direccion_sucursal_origen: '',
                id_direccion_sucursal_destino: '',
                fecha_salida: '',
                fecha_entrega: '',
                dias_entrega: '',
                horas_extra: '',
                cod_metodo_envio_id: '',
                metodo_envio_id: '',
                detalle_metodo_envio_id: '',
                documentos: [],
                documentos_extras: '',
                cant_bultos: '',
                cant_conductor: '1',
                precio_servicio: '',
                peso_bruto: '',
                peso_volumen: '',
                tipo_unidad: '1',
                medidas: '',
                flete: '',
                falso_flete_provincia: '',
                flete_cancelacion: '',
                flete_visita_extra: '',
                flete_hora_extra: '',
                flete_local_urgencia: '',
                gastos_admin: '',
                gastos_total: '',
                detalle_gastos_admin: '',
                id_causa_visita: '',
                detalle_causa_visita: '',
                detalle_mercaderia: '',
                id_modalidades_envio: '3',
                id_tipo_envio: '',
                id_solicitudes_envio: '',
                detalle_solicitud_envio: 'EMERGENCIA',
                id_estados_envio: '1',
                id_causa_entrega: '',
                detalle_causa_entrega: '',
                lead_time_esperado: '',
                cumplimiento_lead_time: '',
                causa_cumplimiento_lead_time: '',
                detalle_cumplimiento_lead_time: '',
                lead_time_cargos: '',
                causa_cumplimiento_lead_time_cargos: '',
                estado_retorno_cargos: '',
                lead_time_retorno_doc: '',
                cumplimiento_lead_time_retorno: '',
                causa_cumplimiento_lead_time_retorno: '',
                conformidad: '',
                observaciones: this.form.observaciones,
                hora_salida: '',
                hora_llegada: '',
                tipo_paquete: 'mercaderia'
            };
        },
        generarRangosHoras() {
            let rangos = []
            let incremental = 0
            if (this.$route.params.tipo_envio == 'exclusivo') {
                incremental = 1
            } else {
                incremental = 3
            }

            for (let i = 8; i < 18; i++) {
                let inicio = this.formatearHora(i)
                let fin = this.formatearHora(i + incremental)
                rangos.push(`${inicio} - ${fin}`)
            }
            return rangos
        },
        formatearHora(hora) {
            let sufijo = hora < 12 ? 'AM' : 'PM'
            let hora12 = hora <= 12 ? hora : hora - 12
            return `${hora12}:00 ${sufijo}`
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('es-PE', {
                style: 'currency',
                currency: 'PEN',
                minimumFractionDigits: 0,
            }).format(value)
        },
        async getCodigoMetodoEnvio() {
            try {
                const response = await axios.get('cod-metodo-envio')
                this.codigosMetodoEnvio = response.data // Usar response.data
            } catch (error) {
                console.error('Error cargando códigos de método de envío:', error)
            }
        },

        async getDetalleMetodoEnvio() {
            if (this.form.cod_metodo_envio_id) {
                this.errors.cod_metodo_envio_id = false // Se elimina el error cuando se selecciona un valor válido
            }
            try {
                const response = await axios.get(
                    'detalle-envio-by-codigo/' + this.form.cod_metodo_envio_id,
                )
                this.detallesMetodoEnvio = response.data // Usar response.data
            } catch (error) {
                console.error('Error cargando detalles de método de envío:', error)
            }
        },

        async getSolicitudesEnvio() {
            this.solicitudesEnvio =
                [

                    {
                        "id": 2,
                        "nombre": "URGENCIA",
                        "created_at": "2025-02-21T20:49:37.000000Z",
                        "updated_at": "2025-02-21T20:49:37.000000Z"
                    },
                    {
                        "id": 3,
                        "nombre": "EMERGENCIA",
                        "created_at": "2025-02-21T20:49:37.000000Z",
                        "updated_at": "2025-02-21T20:49:37.000000Z"
                    },


                ]
            // try {
            //     const response = await axios.get('solicitudes-envio')
            //     this.solicitudesEnvio = response.data // Usar response.data
            // } catch (error) {
            //     console.error('Error cargando detalles de método de envío:', error)
            // }
        },

        async getServiciosExtras() {
            try {
                const response = await axios.get('servicios-extras')
                this.serviciosExtras = response.data // Usar response.data
            } catch (error) {
                console.error('Error cargandoservicios Extras:', error)
            }
        },

        async getTipoEnvio() {
            let ids = []
            if (this.tipoEnvio == 'exclusivo') {
                ids = [5]
            } else if (this.tipoEnvio == 'consolidado') {
                ids = [5]
            } else if (this.tipoEnvio == 'aereo') {
                ids = [1, 3]
            }

            try {
                const response = await axios.get('tipos-envio', {
                    params: { ids },
                })
                this.tiposEnvio = response.data // Usar response.data
            } catch (error) {
                console.error('Error cargando códigos de tipo de envío:', error)
            }
        },
        async getEmpresas() {
            try {
                const response = await axios.get('empresas')
                this.empresas = response.data // Usar response.data
            } catch (error) {
                console.error('Error cargando empresas:', error)
            }
        },
        async getSucursalesRemitente() {
            try {
                const response = await axios.get(
                    'empresa-sucursales/' + this.form.remitente,
                )
                this.sucursalesRemitente = response.data // Usar response.data
                this.buscarDireccionRemitente();
            } catch (error) {
                console.error('Error cargando sucursales:', error)
            }
        },
        async getEmpresaRemitente() {
            try {
                const response = await axios.get(
                    'empresa-by-ruc/' + this.form.ruc_remitente,
                )
                this.form.remitente = await response.data.id // Usar response.data
                this.getSucursalesRemitente()
            } catch (error) {
                console.error('Error buscando empresa:', error)
            }
        },
        async getEmpresaDestinatario() {
            try {
                const response = await axios.get(
                    'empresa-by-ruc/' + this.form.ruc_destinatario,
                )
                this.form.destinatario = await response.data.id // Usar response.data
                this.getSucursalesDestinatario()
            } catch (error) {
                console.error('Error cargando empresas:', error)
            }
        },
        async getSucursalesDestinatario() {
            this.limpiarPrecios()
            this.sucursalDestinatario = {}
            try {
                const response = await axios.get(
                    'empresa-sucursales/' + this.form.destinatario,
                )
                this.sucursalesDestinatario = await response.data


            } catch (error) {
                console.error('Error cargando sucursales:', error)
            }
        },
        async getTipoUnidades() {
            try {
                let ids = [6, 7];
                const params = ids.length ? { ids: ids.join(',') } : {} // Convertir array a string si hay IDs
                const response = await axios.get('tipo-unidades', { params })
                this.tipoUnidades = response.data

            } catch (error) {
                console.error('Error cargando tipoUnidades:', error)
            }
        },

        buscarUnidad() {
            this.detalleUnidad = this.tipoUnidades.find(
                (item) => item.id == this.form.tipo_unidad_asignada,
            )
            this.buscarPrecio()
        },
        buscarDireccionRemitente() {
            if (this.form.id_direccion_sucursal_origen) {
                this.errors.id_direccion_sucursal_origen = false
                this.sucursalRemitente = this.sucursalesRemitente.find(
                    (item) => item.id == this.form.id_direccion_sucursal_origen,
                )
            }
            console.log("this.sucursalRemitente ", this.sucursalRemitente)
        },
        buscarDireccionDestinatario() {
            this.sucursalDestinatario = this.sucursalesDestinatario.find(
                (item) => item.id == this.form.id_direccion_sucursal_destino,
            )
            this.buscarPrecio()
        },
        async buscarPrecio() {
            try {
                // Validar que hay vehículo seleccionado
                if (!this.form.tipo_unidad_asignada) {
                    console.warn('No hay unidad asignada para calcular precio');
                    this.form.precio_servicio = 0;
                    return;
                }

                // Definir precios por tipo de vehículo (considerar mover esto a configuración)
                const PRECIOS_POR_TIPO = {
                    1: 285,  // Tipo 1
                    2: 485,  // Tipo 2  
                    6: 185,  // Tipo 6
                    7: 135   // Tipo 7
                };

                // Calcular precio basado en el tipo
                const precioCalculado = PRECIOS_POR_TIPO[Number(this.form.tipo_unidad_asignada)];

                if (precioCalculado === undefined) {
                    console.warn(`No hay precio definido para el tipo de vehículo: ${this.form.tipo_unidad_asignada}`);
                    this.form.precio_servicio = 0;
                } else {
                    this.form.precio_servicio = precioCalculado;
                    console.log(`Precio calculado: S/. ${precioCalculado} para tipo de vehículo ${this.form.tipo_unidad_asignada}`);
                }

            } catch (error) {
                console.error('Error al calcular precio del servicio:', error);
                this.form.precio_servicio = 0;
            }
        },

        limpiarPrecios() {
            this.form.lead_time_esperado = ''
            this.form.falso_flete_provincia = 0
            this.form.precio_servicio = 0
        },

        openModalDirecciones(empresa_id, data, tipoDireccion) {
            this.sucursalesData = data;
            this.direccionEdit.empresa_id = empresa_id;
            this.showModalDirecciones = true;
            this.tipoDireccion = tipoDireccion
            //this.cargarDirecciones();
        },
        resetDireccion() {
            this.direccionEdit = {
                empresa_id: this.direccionEdit.empresa_id, // se conserva: el modal sigue siendo de la misma empresa
                nombre: '',
                direccion: '',
                distrito_id: null,
                nombre_contacto: '',
                cargo_contacto: '',
                telefono_contacto: '',
                email_contacto: '',
            };
        },
        agregarDocumento() {
            if (!this.formDocumento.detalle_metodo_envio_id) {
                this.errors.detalle_metodo_envio_id = 'Campo obligatorio'
                return
            }

            this.form.documentos.push({ ...this.formDocumento });
            this.errors.documentos = false
            this.formDocumento = {
                detalle_metodo_envio_id: '',
                guia_remitente: '',
                nro_pedido: '',
                orden_compra: '',
                numero_factura: '',
                documentos_extras: '',
                otm: ''
            };

        },
        eliminarDocumento(index) {
            this.form.documentos.splice(index, 1);
        },
        agregarPaquete() {
            if (
                !this.nombrePaquete ||
                !this.alto ||
                !this.ancho ||
                !this.largo ||
                !this.pesoReal
            ) {
                alert('Completa todos los campos antes de agregar el paquete.')
                return
            }

            this.paquetes.push({
                nombre: this.nombrePaquete,
                alto: this.alto,
                ancho: this.ancho,
                largo: this.largo,
                peso: this.pesoReal,
                pesoVolumetrico: this.pesoVolumetrico,
                costo: this.costoPaquete,
            })

            // Limpiar los campos
            this.nombrePaquete = ''
            this.alto = ''
            this.ancho = ''
            this.largo = ''
            this.pesoReal = ''
            this.pesoVolumetrico = 0
            this.costoPaquete = 0
        },
        eliminarPaquete(index) {
            this.paquetes.splice(index, 1)
        },

        calcularCosto() {
            this.pesoVolumetrico = (this.alto * this.ancho * this.largo) / 5000
            let mayorPeso = Math.max(this.pesoReal, this.pesoVolumetrico)
            this.costoPaquete = parseFloat((mayorPeso * this.costoPorKg).toFixed(2))
        },
        cargarDatosServicio() {
            if (this.servicioSeleccionado) {
                this.costoPorHora = this.servicioSeleccionado.costo_por_hora
                this.costoPorDia = this.servicioSeleccionado.costo_por_dia
                this.calcularTotal()
            }
        },
        // Calcular el total basado en cantidad
        calcularTotal() {
            if (this.servicioSeleccionado) {
                if (this.costoPorHora > 0) {
                    this.total = (this.costoPorHora * this.cantidad).toFixed(2)
                } else {
                    this.total = (this.costoPorDia * this.cantidad).toFixed(2)
                }
            }
        },
        editarDireccion(direccion) {
            this.direccionEdit = { ...direccion };
            this.editandoDireccion = true;
            this.editId = direccion.id;
            this.cargarProvincias();
            this.cargarDistritos();
        },
        async eliminarDireccion(id) {
            try {
                await axios.delete(`sucursales/${id}`);
                this.getSucursalesDestinatario();
            } catch (error) {
                console.error('Error al eliminar dirección:', error);
            }
        },
        async guardarDireccion() {
            try {
                if (this.editandoDireccion) {
                    await axios.put(`sucursales/${this.editId}`, this.direccionEdit);
                } else {
                    await axios.post('sucursales', this.direccionEdit);
                }
                this.resetDireccion();  // Reset form

                if (this.tipoDireccion == "remitente") {
                    await this.getSucursalesRemitente();
                    this.sucursalesData = this.sucursalesRemitente;
                } else {
                    await this.getSucursalesDestinatario();
                    this.sucursalesData = this.sucursalesDestinatario;
                }

            } catch (error) {
                console.error('Error al guardar dirección:', error);
            }
        },
        // Agregar el servicio a la tabla
        agregarServicio() {
            if (!this.servicioSeleccionado || this.cantidad <= 0) {
                alert('Seleccione un servicio y una cantidad válida.')
                return
            }

            this.serviciosAgregados.push({
                servicio: this.servicioSeleccionado.servicio,
                cantidad: this.cantidad,
                costoPorHora: this.costoPorHora,
                costoPorDia: this.costoPorDia,
                total: this.total,
            })

            // Reiniciar los campos
            this.servicioSeleccionado = ''
            this.cantidad = 1
            this.costoPorHora = 0
            this.costoPorDia = 0
            this.total = 0
        },
        // Eliminar un servicio de la tabla
        eliminarServicio(index) {
            this.serviciosAgregados.splice(index, 1)
        },
        validateForm() {
            this.errors = {}

            if (!this.form.cod_metodo_envio_id) {
                this.errors.cod_metodo_envio_id = 'Campo obligatorio'
            }
            if (!this.form.id_solicitudes_envio) {
                this.errors.id_solicitudes_envio = 'Campo obligatorio'
            }
            if (!this.form.fecha_salida) {
                this.errors.fecha_salida = 'Campo obligatorio'
            }
            if (!this.form.hora_salida) {
                this.errors.hora_salida = 'Campo obligatorio'
            }
            if (!this.form.fecha_entrega) {
                this.errors.fecha_entrega = 'Campo obligatorio'
            }
            if (!this.form.hora_llegada) {
                this.errors.hora_llegada = 'Campo obligatorio'
            }
            if (!this.form.ruc_remitente) {
                this.errors.ruc_remitente = 'Campo obligatorio'
            }
            if (!this.form.remitente) {
                this.errors.remitente = 'Campo obligatorio'
            }
            if (!this.form.id_direccion_sucursal_origen) {
                this.errors.id_direccion_sucursal_origen = 'Campo obligatorio'
            }
            if (!this.form.ruc_destinatario) {
                this.errors.ruc_destinatario = 'Campo obligatorio'
            }
            if (!this.form.destinatario) {
                this.errors.destinatario = 'Campo obligatorio'
            }
            if (!this.form.id_direccion_sucursal_destino) {
                this.errors.id_direccion_sucursal_destino = 'Campo obligatorio'
            }
            if (!this.form.documentos.length) {
                this.errors.documentos = 'Debe agregar al menos un documento'
            }
            return Object.keys(this.errors).length === 0
        },

        submitDesdePadre() {
            return this.submitForm();
        },

        async submitForm() {
            if (!this.validateForm()) {
                console.log('Formulario inválido:', this.errors)
                return
            }

            const confirmacion = await Swal.fire({
                title: '¿Confirma el envío?.',
                text: 'Tenga en cuenta que si cancela el servicio, igual se efectuará el cobro.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, enviar',
                cancelButtonText: 'Cancelar',
            })

            if (!confirmacion.isConfirmed) {
                return
            }

            try {
                let response
                switch (this.tipoEnvio) {
                    case 'exclusivo':
                        this.form.id_modalidades_envio = 3
                        break
                    case 'consolidado':
                        this.form.id_modalidades_envio = 2
                        break
                    case 'aereo':
                        this.form.id_modalidades_envio = 4
                        break
                }

                this.form.id_destinatario_final = this.form.id_direccion_sucursal_destino;
                this.form.id_remitente_final = this.form.id_direccion_sucursal_origen;

                this.form.metodo_envio_id = this.form.cod_metodo_envio_id
                this.form.observacion_final = this.form.observaciones
                if (this.envioId) {
                    response = await axios.put(`envios-locales/${this.envioId}`, this.form)

                    Swal.fire({
                        icon: 'success',
                        title: 'Envío Actualizado',
                        text: 'Los datos se han actualizado correctamente.',
                    })
                    this.$router.push({ name: 'ShippingLocalDocumentList' });
                } else {
                    response = await axios.post('envios-locales', this.form)
                    this.pedidoResponse = response.data

                    Swal.fire({
                        icon: 'success',
                        title: 'Envío Guardado',
                        html: `Los datos se han guardado correctamente.<br><strong>Su número de rastreo es: ${this.pedidoResponse.rastreo}</strong> 
    <br>Los datos se mostrarán en la lista de envío dentro de una hora. 
    <br> La unidad estará llegando en una hora y media al punto de partida `,
                    }).then(() => {
                        this.$router.push('/listado-envios-documentos-locales')
                    })
                    this.$router.push({ name: 'ShippingLocalDocumentList' });
                    return response.data;
                }
            } catch (error) {
                console.error(error)

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un problema al registrar el envío.',
                })
            }
        },
    },
}
</script>

<style scoped>
.form-group {
    margin-bottom: 10px;
    margin-top: 10px;
}

/* ── Cards ── */
.bg-card {
    background-color: #fff !important;
    border: 1px solid #e8eaf6;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(63,81,181,0.07);
}
.bg-card .card-header {
    background: linear-gradient(90deg, #3f51b5 0%, #5c6bc0 100%) !important;
    color: #fff !important;
    font-weight: 700;
    font-size: 0.9rem;
    border-radius: 9px 9px 0 0 !important;
    padding: 11px 18px;
    border-bottom: none;
    display: flex;
    align-items: center;
    gap: 8px;
}

/* ── Labels ── */
label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #546e7a;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-bottom: 3px;
}
label.required::after {
    content: ' *';
    color: #e53935;
}

/* ── Inputs ── */
.form-control, .form-select {
    font-size: 0.85rem;
    border-color: #e0e0e0;
    border-radius: 6px;
}
.form-control:focus, .form-select:focus {
    border-color: #5c6bc0;
    box-shadow: 0 0 0 0.2rem rgba(63,81,181,0.12);
}
.form-control:disabled, .form-control[readonly] {
    background: #f5f6ff;
    color: #546e7a;
}

/* ── Tables ── */
.table-font-small {
    font-size: 0.78rem;
}
thead th,
tbody tr {
    text-align: center;
}

/* ── Misc ── */
.font-small { font-size: 0.9rem; }
.col-lg-21 { width: 12.5%; }
.hover-pointer { cursor: pointer; }
.no-resize { resize: none; }

@media (min-width: 1200px) and (max-width: 1400px) {
    .col-lg-2 { width: 25%; }
}

.table th:nth-child(1) { width: 15%; }
.table th:nth-child(4) { width: 12%; }
.swal-superior { z-index: 9999 !important; }
</style>